import React from "react";
import "./styles/CustomLoader.css";

export default function CustomLoader() {
  return (
    <div className="custom-loader">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="loader-bar" style={{ backgroundColor: "#27437f" }} />
      ))}
    </div>
  );
}
